import { Injectable } from '@angular/core';
import { HttpSecureClient } from 'path-shared/services/http/httpSecureClient';
import { AuthGuardService } from 'path-shared/services/authentication/auth-guard.service';
import { Observable } from 'rxjs';
import { config } from 'path-shared/configuration/config';
import { api } from 'path-shared/configuration/urls';
import { Festiu } from '../models/festiu.model';

const defaultSortParam = 'dia';
const defaultSortDirection = 'desc';

@Injectable()
export class FestiusService {
  constructor(private http: HttpSecureClient, private authGuard: AuthGuardService) {}

  setFestiu(festiu: Festiu): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.post(config.urls['apiUrl'] + api.endpoints['urlSetFestiu'], festiu);
    }
  }

  removeFestiu(secure_id): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.delete(config.urls['apiUrl'] + api.endpoints['urlDeleteFestiu'].replace('{secure_id}', secure_id), null);
    }
  }

  getFestiu(secure_id): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlGetFestiu'].replace('{secure_id}', secure_id), null);
    }
  }

  publicar(): Observable<any> {
    if (this.authGuard.canActivate()) {
      return this.http.get(config.urls['apiUrl'] + api.endpoints['urlPublicarFestiu'], null);
    }
  }

  // generateExcel(filter: ColorFilter, sortDir: string, sortField: string): Observable<any> {
  //   const start = 0;
  //   const pageSize = 1000;

  //   sortField = sortField === undefined ? defaultSortParam : sortField;
  //   sortDir = sortDir === '' ? defaultSortDirection : sortDir;
  //   const params = new ColorsFilterService().createFilterParams(filter, start, pageSize, sortField, sortDir);

  //   if (this.authGuard.canActivate()) {
  //     return this.http.getFile(config.urls['apiUrl'] + api.endpoints['urlColorsExcel'],  params );
  //   }
  // }
}
